import React, { useState, useRef } from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

// Publicar Status/Stories do número conectado (campanhas).
// Texto (com cor de fundo), imagem ou vídeo. Visível para os contatos do número.
const StatusModal = ({ open, onClose, whatsappId }) => {
	const [tab, setTab] = useState(0); // 0=texto, 1=imagem, 2=vídeo
	const [text, setText] = useState("");
	const [bgColor, setBgColor] = useState("#0a7d3e");
	const [caption, setCaption] = useState("");
	const [file, setFile] = useState(null);
	const [sending, setSending] = useState(false);
	const fileRef = useRef(null);

	const reset = () => {
		setText("");
		setCaption("");
		setFile(null);
		setBgColor("#0a7d3e");
		setTab(0);
	};

	const handleClose = () => {
		if (sending) return;
		reset();
		onClose();
	};

	const handlePublish = async () => {
		if (!whatsappId) return;
		setSending(true);
		try {
			if (tab === 0) {
				if (!text.trim()) { toast.warn("Digite o texto do status."); setSending(false); return; }
				await api.post(`/whatsapp/${whatsappId}/status/text`, {
					text: text.trim(),
					backgroundColor: bgColor || undefined,
				});
			} else {
				if (!file) { toast.warn("Escolha um arquivo."); setSending(false); return; }
				const fd = new FormData();
				fd.append("media", file);
				if (caption.trim()) fd.append("caption", caption.trim());
				await api.post(`/whatsapp/${whatsappId}/status/media`, fd, {
					headers: { "Content-Type": "multipart/form-data" },
				});
			}
			toast.success("Status publicado! 📣");
			reset();
			onClose();
		} catch (err) {
			toastError(err);
		} finally {
			setSending(false);
		}
	};

	const accept = tab === 1 ? "image/*" : "video/*";

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
			<DialogTitle>Publicar Status (campanha)</DialogTitle>
			<DialogContent dividers>
				<Tabs
					value={tab}
					onChange={(_, v) => { setTab(v); setFile(null); }}
					variant="fullWidth"
					style={{ marginBottom: 12 }}
				>
					<Tab label="Texto" />
					<Tab label="Imagem" />
					<Tab label="Vídeo" />
				</Tabs>

				{tab === 0 && (
					<>
						<TextField
							autoFocus
							fullWidth
							multiline
							minRows={3}
							variant="outlined"
							label="Texto do status"
							value={text}
							onChange={e => setText(e.target.value)}
							inputProps={{ maxLength: 700 }}
						/>
						<div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 12 }}>
							<Typography variant="caption" style={{ color: "#555" }}>Cor de fundo:</Typography>
							<input type="color" value={bgColor} onChange={e => setBgColor(e.target.value)}
								style={{ width: 40, height: 28, border: "none", background: "none", cursor: "pointer" }} />
							<div style={{
								flex: 1, minHeight: 48, borderRadius: 6, background: bgColor,
								display: "flex", alignItems: "center", justifyContent: "center",
								color: "#fff", fontWeight: 600, padding: "6px 10px", textAlign: "center",
								whiteSpace: "pre-wrap", wordBreak: "break-word",
							}}>
								{text || "Pré-visualização"}
							</div>
						</div>
					</>
				)}

				{(tab === 1 || tab === 2) && (
					<>
						<Button variant="outlined" onClick={() => fileRef.current?.click()} style={{ marginBottom: 8 }}>
							{file ? `Selecionado: ${file.name}` : `Escolher ${tab === 1 ? "imagem" : "vídeo"}`}
						</Button>
						<input
							ref={fileRef}
							type="file"
							accept={accept}
							style={{ display: "none" }}
							onChange={e => setFile(e.target.files?.[0] || null)}
						/>
						<TextField
							fullWidth
							variant="outlined"
							label="Legenda (opcional)"
							value={caption}
							onChange={e => setCaption(e.target.value)}
							inputProps={{ maxLength: 700 }}
						/>
					</>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="secondary" disabled={sending}>Cancelar</Button>
				<Button onClick={handlePublish} color="primary" variant="contained" disabled={sending}
					startIcon={sending ? <CircularProgress size={16} style={{ color: "#fff" }} /> : null}>
					{sending ? "Publicando..." : "Publicar"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default StatusModal;
